
//var myapp = angular.module("myapp", ["kendo.directives"]);
//$("[data-toggle='tooltip']").tooltip();
// Sample directive.  Activate it by passing my-grid attribute to
// the div which constructs the grid.  It expects your div to also
// have a kendo-grid attribute, to activate the Kendo UI directive
// for creating a grid.
angular.module('EMR.Admin').directive('emrHierarchyGrid', ['$compile', function ($compile) {
    var directive = {
        restrict: 'A',
		scope: true,
		priority: -1,
        controller: ['$scope', function ($scope) {
            window.crap = $scope;

            //select all check box ng-click event handler, Which is used to handle select/deselect all the checkboxes existing in grid rows
            $scope.toggleSelectAll = function (ev) {
                var grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
                var items = grid.dataSource.data(); //getting data source of the grid

                //looping each item and set selected flag to true/false
                items.forEach(function (item) {
                    item.selected = ev.target.checked; //setting select all checkbox checked state to the item.selected property
                });
            };

            //single check box selection checked
            $scope.toggleSelectSingle = function (ev, currentRow) {
                var grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
                var isMultiSelect = grid.options.selectable;
                var items = grid.dataSource.data(); //getting data source of the grid

                if (isMultiSelect == "single" || isMultiSelect == "single row") {
                    //looping each item and set selected flag to true for only selected item or row
                    items.forEach(function (item) {
                        if (item.uid == currentRow.uid) {
                            item.selected = true; //setting select checkbox checked state to the item.selected property                           
                            grid.table.find("tr[data-uid='" + item.uid + "']").addClass("k-state-selected");//adding the state selected
                        }
                        else {
                            item.selected = false; //setting select checkbox checked state to the item.selected property                           
                            grid.table.find("tr[data-uid='" + item.uid + "']").removeClass("k-state-selected");//removing the state selected
                        }
                    });
                }
                else {//multiple case
                    if (currentRow.selected) {
                        currentRow.selected = false;
                        grid.table.find("tr[data-uid='" + currentRow.uid + "']").removeClass("k-state-selected");//removing the state selected
                    }
                    else {
                        currentRow.selected = true;
                        grid.table.find("tr[data-uid='" + currentRow.uid + "']").addClass("k-state-selected");//adding the state selected
                    }
                }
            };

            ////select all check box onClick event handler, Which is used to handle select/deselect all the checkboxes existing in grid rows
            //toggleSelectAllForJS = function (gridID, obj) {
            //    var grid = $("#" + gridID).data("kendoGrid"); //getting grid instance based on grid id
            //    var items = grid.dataSource.data(); //getting data source of the grid

            //    //looping each item and set selected flag to true/false
            //    items.forEach(function (item) {
            //        item.selected = obj.checked; //setting select all checkbox checked state to the item.selected property
            //    });

            //    grid.dataSource.data(items); //refreshing data source
            //};
            ////this method is useful in changing the display sequence of the rows in the grid 
            //kendoGridChangeDisplaySequenceOfRows = function (grid, displaySequenceMoveType) {

            //    if (!hasValue(grid) || !hasValue(displaySequenceMoveType)) return;


            //    var currentDataItem = grid.dataItem(grid.select());

            //    if (!hasValue(currentDataItem))
            //        return;

            //    var idx = grid.dataSource.indexOf(currentDataItem);

            //    if (displaySequenceMoveType == EMRGridDisplaySequence.MOVEDOWN) {
            //        if (hasValue(grid.select().next())) {
            //            var targetDatItem = grid.dataItem(grid.select().next());
            //            var targetIdx = idx + 1;
            //        }
            //    }
            //    if (displaySequenceMoveType == EMRGridDisplaySequence.MOVEUP) {
            //        if (hasValue(grid.select().prev())) {
            //            var targetDatItem = grid.dataItem(grid.select().prev());
            //            var targetIdx = idx - 1;
            //        }
            //    }

            //    if (hasValue(currentDataItem) && hasValue(targetDatItem)) {

            //        grid.dataSource.remove(targetDatItem);
            //        grid.dataSource.insert(idx, targetDatItem);
            //        grid.dataSource.remove(currentDataItem);
            //        grid.dataSource.insert(targetIdx, currentDataItem);
            //        grid.select(grid.table.find("tr:eq(" + targetIdx + ")"));

            //        ////SCROLLING BASED ON MOVE UP DISPLAY SEQUENCE BUTTON.
            //        var row = grid.table.find("tr:eq(" + targetIdx + ")");
            //        // row[0].scrollIntoView();
            //        grid.content.scrollTop(0); // we HAVE to reset the scroll first.
            //        grid.content.scrollTop(row.offset().top - grid.content.offset().top - 45);

            //    }

            //};


            //makePreviewColumnOnBound = function (event) {

            //    if (event.sender.dataSource.data().length > 0) {

            //        //                    var visibleCount = 0;
            //        //                    $.each(event.sender.columns, function (index, item) {
            //        //                        if (item.hidden == null || item.hidden == undefined || item.hidden == false) {
            //        //                            visibleCount++;
            //        //                        }
            //        //                    });

            //        //                    if (event.sender.options.showCheckBoxColumn) {
            //        //                        visibleCount--;
            //        //                    }
            //        var visibleCount = event.sender.columns.length;

            //        event.sender.tbody.find("tr").each(function () {
            //            var $this = $(this);
            //            var dataItem = event.sender.dataSource.getByUid(($this).attr('data-uid'));
            //            if (hasValue(dataItem)) {
            //                if (event.sender.options.previewColumn != null && event.sender.options.previewColumn != undefined && event.sender.options.previewColumn != "") {
            //                    if (dataItem[event.sender.options.previewColumn] != null && dataItem[event.sender.options.previewColumn] != undefined && dataItem[event.sender.options.previewColumn] != "") {
            //                        // $("<tr class='k-state-disabled' previewcolumn='true' readonly span style='color : black;background-color : yellow !important;' readonly><td colspan=" + visibleCount + ">" + dataItem[event.sender.options.previewColumn] + "</td></tr>").insertAfter($this);
            //                        $("<div class='k-state-disabled k-emr-previewColumn' previewcolumn='true' readonly span style='color : black;background-color : yellow !important;width : " + $this.width() + "px;' readonly>" + dataItem[event.sender.options.previewColumn] + "</div>").insertAfter($this);
            //                    }
            //                }
            //            }
            //        });

            //        //$(".k-state-disabled").on("click", function (e) {
            //        //    //makeUnselectablePreviewColumn();
            //        //    e.preventDefault();
            //        //    e.stopImmediatePropagation();
            //        //    e.stopPropagation();  //stopping the previous click events  
            //        //});
            //    }

            //};

        }],
        link: function ($scope, $element, $attrs) {

            var groupColumnsLength = 0; // to hold the grouped columns count for current grid
            var options = angular.extend({}, $scope.$eval($attrs.options)); // getting grid options from grid attributes

            if ($scope.$eval($attrs.options) != undefined && $scope.$eval($attrs.options) != null)
                $scope.$eval($attrs.options).resizable = true;

            //var options = $scope.$eval($attrs.kOptions);
            var data = null; // to hold the grid columns which are defined in options
            var detailViewColumnCaptions = null;
            var gridID = '#' + $attrs.id;

            //getting showCheckBoxColumn property from grid options
            //showCheckBoxColumn==true then only we will add the select all checkbox title and template
            if (options.showCheckBoxColumn) {

                //if single selection then no need to show the select all
                if (options.selectable == "single" || options.selectable == "single row") {
                    options.columns.unshift({
                        template: "<input type='checkbox' ng-model='dataItem.selected' ng-click='toggleSelectSingle($event,dataItem)'/>",
                        width: "35px"
                    });
                }
                else {
                    options.columns.unshift({
                        template: "<input type='checkbox' ng-model='dataItem.selected' ng-click='toggleSelectSingle($event,dataItem)'/>",
                        title: "<input type='checkbox' class='selectAllChkBox' ng-click='toggleSelectAll($event)' />",
                        width: "35px"
                    });
                }
            }

            //getting columns from grid options
            data = options.columns;

            if (options == undefined || options.dataSource == undefined || options.dataSource._group == undefined)
                groupColumnsLength = 0; ////set groupColumnsLength to group coluns lengh
            else
                groupColumnsLength = options.dataSource._group.length;


            //if (options.dataSource.group == undefined) //if group columns are not defined
            //    groupColumnsLength = 0; //set groupColumnsLength to zero
            //else if (options.dataSource.group.length == undefined) //if group columns are defied but length is undefinded i.e. group column is defined as like a object with single column but not like an array.
            //    groupColumnsLength = 1;//set groupColumnsLength to 1
            //else
            //    groupColumnsLength = options.dataSource.group.length; ////set groupColumnsLength to group coluns lengh

            //false always as guided by mohan sir on 12/29/2016
            options.mobileRedirect = false;

            //if style tag is not found for the current grid element then only we will construct the styles and add to the current element
            if (!hasValue(options.mobileRedirect) || (hasValue(options.mobileRedirect) && options.mobileRedirect == true)) {
                if ($element.find("style").length === 0) {
                    var css = '<style>@media only screen and (max-width: 500px),(max-device-width: 500px){\n'; //for mobile resolution ,(min-device-width: 768px) and (max-device-width: 1024px) and (orientation:portrait)
                    css += '.hideSelectAll{display: block !important;}';
                    css += gridID + ' table, ' + gridID + ' thead, ' + gridID + ' tbody, ' + gridID + ' th, ' + gridID + ' td, ' + gridID + ' tr {display: block;}';
                    css += '/* Hide table headers (but not display: none;, for accessibility) */';
                    css += gridID + ' thead tr {position: absolute;top: -9999px;left: -9999px; }';
                    css += gridID + ' tr { border: 1px solid #ccc; }';

                    //for master grid
                    css += gridID + ' .k-master-row td { /* Behave  like a "row" */ border: none;border-bottom: 1px solid #eee; position: relative;padding-left: 50% !important;min-height: 25px !important;}';
                    css += gridID + ' .k-master-row td:before {/* Now like a table header */position: absolute;/* Top/left values mimic padding */top: 6px;left: 6px;width: 45%;padding-right: 10px;white-space: nowrap;}';

                    //for detail view grid
                    css += gridID + '  .k-tabstrip-wrapper td { /* Behave  like a "row" */ border: none;border-bottom: 1px solid #eee; position: relative;padding-left: 50% !important;min-height: 25px !important;}';
                    css += gridID + ' .k-tabstrip-wrapper td:before {/* Now like a table header */position: absolute;/* Top/left values mimic padding */top: 6px;left: 6px;width: 45%;padding-right: 10px;white-space: nowrap;}';


                    if (options.groupable || groupColumnsLength > 0) //if grouping is applyed for the current grid
                    {
                        css += gridID + ' .k-group-cell{display: none !important;}'; //removing grouping cell
                        css += gridID + ' .k-grouping-row td{padding-left: 0px !important;}'; // removing left padding for the grouping row
                    }

                    css += gridID + ' .k-detail-row .k-hierarchy-cell{display: none !important;}'; // removing hierarchy cell

                    css += '/*Label the data*/';

                    css += gridID + ' .k-master-row td:nth-of-type(1):before { content: "Expand"; }';

                    if (options.showCheckBoxColumn) //if showCheckBoxColumn is true in grid options
                    {
                        //adding select all checkbox to show in mobile resolution for only multi select grid
                        if (options.selectable == "multiple" || options.selectable == "multiple row") {
                            $element.before('<div class="hideSelectAll" style="display:none;">Select All: <input type="checkbox" class="selectAllChkBox" onclick="toggleSelectAllForJS(\'' + $attrs.id + '\',this)" /></div>');
                        }
                        if (options.groupable || groupColumnsLength > 0)//if grouping is applyed for the current grid
                        {
                            css += gridID + ' .k-master-row td:nth-of-type(' + (groupColumnsLength + 2) + '):before { content: "Select"; }'; //applying Select as caption before checkbox row (which is available after all group rows)

                            //setting row caption for each data field except group rows
                            for (var i = 1; i < data.length; i++) {
                                var style = '' +
                                      gridID + ' .k-master-row td:nth-of-type(' + (i + groupColumnsLength + 2) + '):before {' +
                                          'content: "' + data[i].title + '";' +
                                      '}\n';
                                css += style;
                            }
                        }
                        else {
                            css += gridID + ' .k-master-row td:nth-of-type(1):before { content: "Select"; }'; //applying Select as caption before checkbox row (which is available as first row)

                            //setting row caption for each data field
                            for (var i = 1; i < data.length; i++) {
                                var style = '' +
                                     gridID + ' .k-master-row td:nth-of-type(' + (i + 2) + '):before {' +
                                         'content: "' + data[i].title + '";' +
                                     '}\n';
                                css += style;
                            }
                        }
                    }
                    else //if showCheckBoxColumn is false/undefined in grid options
                    {
                        if (options.groupable || groupColumnsLength > 0)//if grouping is applyed for the current grid
                        {
                            //setting row caption for each data field except group rows
                            for (var i = 0; i < data.length; i++) {
                                var style = '' +
                                      gridID + ' .k-master-row td:nth-of-type(' + (i + groupColumnsLength + 2) + '):before {' +
                                          'content: "' + data[i].title + '";' +
                                      '}\n';
                                css += style;
                            }
                        }
                        else {
                            //setting row caption for each data field
                            for (var i = 0; i < data.length; i++) {
                                var style = '' +
                                      gridID + ' .k-master-row td:nth-of-type(' + (i + 2) + '):before {' +
                                          'content: "' + data[i].title + '";' +
                                      '}\n';
                                css += style;
                            }
                        }
                    }

                    detailViewColumnCaptions = options.detailViewColumnCaptions;

                    //setting row caption for each data field
                    for (var i = 0; i < detailViewColumnCaptions.length; i++) {
                        var style = '' +
                                      gridID + ' .k-tabstrip-wrapper td:nth-of-type(' + (i + 1) + '):before {' +
                                          'content: "' + detailViewColumnCaptions[i].title + '";' +
                                      '}\n';
                        css += style;
                    }


                    css = css + '} \n';
                    css = css + gridID + ' .k-grouping-header{display: none !important;}';
                    //css = css + 'div[data-role="grid"] .k-group-cell, div[data-role="grid"] .k-group-col{width: 1px !important;}';                    
                    css = css + '</style>';
                    if (data.length > 1)
                        $element.html(css); //adding css to the current element
                }
            }
        }
    };
    return directive;
}]);


